import React, { forwardRef } from 'react';
import uuid from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid.v4();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M9.62767 0C4.30838 0 0 4.30838 0 9.62767C0 14.947 4.30838 19.2553 9.62767 19.2553C14.947 19.2553 19.2553 14.947 19.2553 9.62767C19.2553 4.30838 14.947 0 9.62767 0ZM9.62767 16.8484C5.64422 16.8484 2.40692 13.6111 2.40692 9.62767C2.40692 5.64422 5.64422 2.40692 9.62767 2.40692C13.6111 2.40692 16.8484 5.64422 16.8484 9.62767C16.8484 13.6111 13.6111 16.8484 9.62767 16.8484ZM23.1666 21.9511C23.6359 22.4205 23.6359 23.1786 23.1666 23.648C22.6972 24.1173 21.939 24.1173 21.4697 23.648L16.5716 18.8943L18.2685 17.1974L23.1666 21.9511ZM6.01729 8.36405H13.238C13.8999 8.36405 14.4415 8.90561 14.4415 9.56751C14.4415 10.2294 13.8999 10.771 13.238 10.771H6.01729C5.35539 10.771 4.81383 10.2294 4.81383 9.56751C4.81383 8.90561 5.35539 8.36405 6.01729 8.36405Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
